export default function InvalidPage() {
  return (
    <div className="min-h-[60vh]">
      <h1 className="text-center text-5xl my-40">Page Not Found</h1>
    </div>
  );
}
